import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { EnhancedSelectComponent } from './enhanced-select.component';

@Component({
  selector: 'select-field-deprecated',
  templateUrl: './select-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SelectFieldComponent),
    },
  ],
})
export class SelectFieldComponent implements ControlValueAccessor {
  @Input() label: string;
  @Input() loading: boolean = false;
  @Input() help: string;
  @Input() required: boolean;
  @Input() placeholder: string;
  @Input() disabled: boolean;
  @Input() autoFocus: boolean;
  @Output() valueChange = new EventEmitter();

  @ViewChild('selectElement', { static: false })
  selectElement: EnhancedSelectComponent;

  constructor(private readonly cdr: ChangeDetectorRef) {}

  private _value: string;
  get value() {
    return this._value;
  }
  set value(value) {
    this._value = value;
    this.propagateChange(value);
  }

  private propagateChange = (_: any) => {};

  writeValue(value: any) {
    this._value = value;
    this.cdr.markForCheck();
  }

  registerOnChange(fn: (_: any) => {}) {
    this.propagateChange = fn;
  }

  registerOnTouched() {}

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
    this.cdr.markForCheck();
  }

  focus() {
    (<any>this.selectElement).nativeElement.focus();
  }
}
